import {globalWindow} from './browserHelpers';

export function isOnline() {
  return globalWindow.navigator.onLine;
}
